<script>
    import Mobilebtn2 from '../mobilebtn2.svelte';
    import {initializeGsapAnimation} from '../../utils.js';
    import {onMount} from 'svelte';

    let img;
    let main;
    onMount(onStart);
    /**
     */
    function onStart() {
        initializeGsapAnimation(
            main,
            img,
            [
                {scale: 1, duration: 1},
                {scale: 1.2, duration: 1},
            ],
            3,
        );
    }
</script>

<div class="gamerWrraper" bind:this={main}>
    <div class="imageWrraper" bind:this={img}>
        <img
            src="/images/HealerPolished.png"
            alt="robot"
            width="auto"
            height="100%"
        />
    </div>
    <div class="heading">
        <h1>GAMERS</h1>
        <div class="para">
            <p>
                Play in an ever changing world in which you aren’t merely a
                player and also a creator and administrator.
            </p>
            <a href="/gamers">
                <Mobilebtn2
                popup = false
                bgcolor="transparent"
                text="Learn More"
                width="23.364vw"
                height="7.477vw"
                textPadding = '0vw'
                state = "Games"
            />
            </a>
            
        </div>
    </div>
</div>

<style>
    .gamerWrraper {
        width: 100vw;
        overflow: hidden;
        position: relative;
        font-family: "Orbitron";
        background-color: #807cf9;
        height: max(216.355vw, 100vh);
    }
    .imageWrraper {
        left: 0vw;
        top: 20vw;
        width: 152.57vw;
        position: relative;
        transform: scale(0.8);
        transform-origin: left;
        height: max(133.645vw, 61.771vh);
    }
    .heading h1 {
        color: #f4eeec;
        margin-bottom: 0;
        font-weight: 900;
        margin-left: -2.5vw;
        font-size: 21.028vw;
        line-height: 26.402vw;
        text-transform: uppercase;
    }
    .para {
        margin: auto;
        width: 73.832vw;
        margin-top: -5vw;
    }
    .heading p {
        font-weight: 400;
        color: #e4e3ff;
        line-height: 140%;
        font-size: 3.271vw;
        letter-spacing: 0.06em;
    }
</style>
